import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {BasemapConfiguration} from "./map-configuration";
import {WidgetConfiguration} from "./widget-configuration";

@JsonObject()
export class BasemapToggleVisibleElementsConfiguration {
    /**
     * Indicates whether to the title will be displayed. Default is false.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-BasemapToggle.html#VisibleElements)
     */
    @JsonProperty()
    declare title: boolean;
}

@JsonObject()
export class BasemapToggleConfiguration extends WidgetConfiguration {
    /**
     * *Geo.js Property*
     * property to place the widget in one of the Esri UI corners.
     */
    @JsonProperty()
    declare position: "top-left" | "top-right" | "bottom-left" | "bottom-right";

    /**
     * The next basemap for toggling.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-BasemapToggle.html#nextBasemap)
     */
    @JsonProperty()
    declare nextBasemap?: BasemapConfiguration | string;
    /**
     * A reference to the [MapView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-MapView.html) or [SceneView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-SceneView.html).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-BasemapToggle.html#view)
     */
    // @JsonProperty()
    // declare view?: (MapViewConfiguration & { type: "2d" }); // | (SceneViewProperties & { type: "3d" });
    /**
     * The view model for this widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-BasemapToggle.html#viewModel)
     */
    // @JsonProperty()
    // declare viewModel?: BasemapToggleViewModelProperties;
    /**
     * The visible elements that are displayed within the widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-BasemapToggle.html#visibleElements)
     */
    @JsonProperty()
    declare visibleElements?: BasemapToggleVisibleElementsConfiguration;

    constructor() {
        super();
    }
}
